import styled from 'styled-components/macro';

export const FilterNotification = styled.span<{ additionalStyle?: string }>`
  background: ${({ theme }) => theme.colors.primary_dark};
  width: 7px;
  height: 7px;
  border-radius: 100%;
  position: absolute;
  right: 0;

  ${({ additionalStyle }) => additionalStyle && additionalStyle};
`;
